import React from 'react';
import dynamic from 'next/dynamic';
import { DynamicDialogLoader } from '../common';

const InvoicesDialogContent = dynamic<{ message?: string }>(
  () => import('./InvoicesDialogContent').then((m) => m.InvoicesDialogContent),
  {
    ssr: false,
    loading: DynamicDialogLoader
  }
);

export function InvoicesDialog(props: { message?: string }) {
  return <InvoicesDialogContent {...props} />;
}
